import { useQuery } from '@tanstack/react-query'

import { pedir } from './nucleo'

/** Lo que dice el núcleo de la disponibilidad de una web (`GET /api/panel/monitoreo`, de MonitoraWeb). */
export type Disponibilidad = {
  disponible: boolean
  publicada?: boolean
  sinDatos?: boolean
  monitor?: null | {
    url: string
    estado: 'caida' | 'comprobando' | 'en-linea' | 'pausada'
    comprobadaEn: null | string
    respuestaMs: null | number
    media24hMs: null | number
    disponibilidad: { '24h': null | number; '7d': null | number; '30d': null | number }
    caidaAbierta: null | { desde: string; causa: string }
    serie: Array<{ hora: string; mediaMs: null | number; fallos: number }>
    caidas: Array<{ desde: string; hasta: null | string; minutos: number; causa: string; abierta: boolean }>
  }
}

export const useDisponibilidad = (sitio: number, habilitado = true) =>
  useQuery({
    queryKey: ['monitoreo', sitio],
    enabled: habilitado,
    queryFn: () => pedir<Disponibilidad>(`/panel/monitoreo?sitio=${sitio}`),
    // Una caída se ve sola: se vuelve a preguntar cada minuto mientras la pantalla está abierta.
    refetchInterval: 60_000,
    staleTime: 30_000,
  })

/** «99,98 %», o null si todavía no hay ventana que medir. */
export const porcentaje = (valor: null | number | undefined): null | string =>
  typeof valor === 'number' ? `${valor.toLocaleString('es', { maximumFractionDigits: valor >= 99.9 ? 3 : 2 })} %` : null
